export default __webpack_public_path__ + "static/media/tri-image.71defbcf.gif";